import {AuthErrorNames} from '@/services';

export const TOAST = {
  EmptyChallengeResponse: {
    TITLE: 'Code Verification failed',
    DETAILS: `We couldn't verify your code. Please try logging in again or contact support if the issue persists`,
  },
  EmptySignUpUsername: {
    TITLE: 'Start sign up again',
    DETAILS: 'Please back to sign up page and re enter your information',
  },
  EmptySignInUsername: {
    TITLE: 'Start sign in again',
    DETAILS: 'Please enter again your phone and password',
  },
  MAXIMUM_ATTEMPTS: {
    TITLE: 'Maximum attempts',
    DETAILS:
      'You have exceeded the maximum number of attempts. Please try again in a few minutes.',
  },
  INVALID_CODE_VERIFICATION: {
    TITLE: 'Code Mismatch',
    DETAILS: 'The code entered is incorrect please try again.',
  },
  EXPIRED_CODE_VERIFICATION: {
    TITLE: 'Code Expired',
    DETAILS: 'The code entered is expired please try re-send again.',
  },
  NOT_AUTHORIZED_EXCEPTION: {
    TITLE: 'Please Sign In',
    DETAILS: 'Please go back to sign in and try again.',
  },
  ALIAS_EXISTS_EXCEPTION: {
    TITLE: 'Email or Phone number already registered',
    DETAILS: 'Please log in with the Modak app.',
  },
  SIGN_IN_EXCEPTION: {
    TITLE: 'Start sign in again',
    DETAILS: 'Please re-enter phone and password.',
  },
  FATAL_VERIFICATION: {
    TITLE: 'Oops! Something went wrong',
    DETAILS:
      'We couldn’t complete the operation at this time. Please try again later. If the issue persists please contact our support team.',
  },
  RESEND_CODE: {
    TITLE: 'Code sent to your mobile',
    DETAILS: 'We just sent the verification code via SMS',
  },
  SEND_CODE_ERROR: {
    TITLE: 'Verification Code Request Error',
    DETAILS:
      'Oops! Something went wrong while requesting the verification code. Please try again later. If the issue persists, contact our support team for assistance. Sorry for the inconvenience.',
  },
  CONFIRMED_ALREADY: {
    TITLE: 'User Already Confirmed',
    DETAILS:
      'Your account has already been confirmed. Please proceed to sign in.',
  },
  CHALLENGE_RESPONSE_REQUIRED: {
    TITLE: 'Please Sign In',
    DETAILS:
      'Your account is already set up. Go to the login page to access your account.',
  },
  ERROR_SIGN_IN_PROCESS: {
    TITLE: 'Unable to Continue',
    DETAILS:
      "We couldn't complete your login or registration. Please go back and try again.",
  },
  TEMPORARY_ISSUE: {
    TITLE: 'Something went wrong',
    DETAILS:
      'We’re having a temporary issue on our side. Please wait a few minutes and try again.',
  },
};

export const errorMap = {
  [AuthErrorNames.EmptyChallengeResponse]: TOAST.EmptyChallengeResponse,
  [AuthErrorNames.EmptySignUpUsername]: TOAST.EmptySignUpUsername,
  [AuthErrorNames.EmptySignInUsername]: TOAST.EmptySignInUsername,
  [AuthErrorNames.LimitExceededException]: TOAST.MAXIMUM_ATTEMPTS,
  [AuthErrorNames.CodeMismatchException]: TOAST.INVALID_CODE_VERIFICATION,
  [AuthErrorNames.ExpiredCodeException]: TOAST.EXPIRED_CODE_VERIFICATION,
  [AuthErrorNames.UserSignInException]: TOAST.SIGN_IN_EXCEPTION,
  [AuthErrorNames.NotAuthorizedException]: TOAST.NOT_AUTHORIZED_EXCEPTION,
  [AuthErrorNames.AliasExistsException]: TOAST.ALIAS_EXISTS_EXCEPTION,
  [AuthErrorNames.UnexpectedLambdaException]: TOAST.TEMPORARY_ISSUE,
};

export const errorMessagesMap: Record<
  string,
  {TITLE: string; DETAILS: string}
> = {
  'User cannot be confirmed. Current status is CONFIRMED':
    TOAST.CONFIRMED_ALREADY,
  'challengeResponse is required to confirmSignIn':
    TOAST.CHALLENGE_RESPONSE_REQUIRED,
  'Invalid code or auth state for the user.': TOAST.INVALID_CODE_VERIFICATION,
  'An error occurred during the sign in process. This most likely occurred due to: 1. signIn was not called before confirmSignIn. 2. signIn threw an exception. 3. page was refreshed during the sign in flow and session has expired.':
    TOAST.ERROR_SIGN_IN_PROCESS,
  'An account with the phone_number already exists.':
    TOAST.ALIAS_EXISTS_EXCEPTION,
};

export const defaultToast = TOAST.FATAL_VERIFICATION;

export const maxLengthCode = 6;

export const delayAfterConfirmSignUp = 3000;
